<rs-general-dialog
  [visible]="(shouldDisplay$ | async) ?? false"
  dialogTitle=""
  i18n-confirmText
  confirmText="Ok"
  [showHeader]="false"
  [dismissableMask]="true"
  i18n-ariaLabel
  ariaLabel="About"
  [dialogStyle]="{ width: '33rem', maxWidth: '92vw', maxHeight: '90vh' }"
  (confirmAction)="closeAboutDialog()"
  (exitAction)="closeAboutDialog()"
>
  <img
    [src]="logos.large"
    alt=""
    aria-hidden="true"
    class="block mx-auto w-full"
    style="max-width: 26rem; max-height: 30vh; object-fit: contain"
  />

  <div class="flex flex-column align-items-center gap-1 mt-4 md:mt-6">
    <p class="my-0">
      <ng-container i18n>Username:</ng-container>
      <strong class="ml-1 lowercase">{{ loggedInUsername | async }}</strong>
    </p>

    <p class="my-0">
      &copy;
      <rs-copyright-component />
      <ng-container i18n>All rights reserved.</ng-container>
    </p>

    <p class="my-0">
      {{ customerFacingVersion }}
    </p>
  </div>
</rs-general-dialog>
